/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateConsultationMessageModel,
  ICreateConsultationMessageRequest,
  IMappers,
  ICreateConsultationMessageResponse,
  ICreateConsultationMessageResponseError,
  TCreateConsultationMessageResponse,
} from './types';

const defaultConfig: TCreateConsultationMessageModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v1/create-consultation-message/',
  hostType: 'api',
} as TCreateConsultationMessageModel;

function createCreateConsultationMessageModel(
  parameters: ICreateConsultationMessageRequest,
): TCreateConsultationMessageModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateConsultationMessageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateConsultationMessageRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateConsultationMessage<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateConsultationMessageOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCreateConsultationMessageResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCreateConsultationMessageModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateConsultationMessageResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateConsultationMessageResponseError);
    }
  }

  return { response, statusCode } as TCreateConsultationMessageResponse;
}

export { defaultConfig, createCreateConsultationMessageModel, fetchCreateConsultationMessage };
